import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './co2-vs-fiber-laser/HeroSection';
import { IntroSection } from './co2-vs-fiber-laser/IntroSection';
import { FiberAdvantagesSection } from './co2-vs-fiber-laser/FiberAdvantagesSection';
import { CO2AdvantagesSection } from './co2-vs-fiber-laser/CO2AdvantagesSection';
import { CO2DisadvantagesSection } from './co2-vs-fiber-laser/CO2DisadvantagesSection';
import { VideosSection } from './co2-vs-fiber-laser/VideosSection';
import { AdditionalLinksSection } from './co2-vs-fiber-laser/AdditionalLinksSection';
export function CO2vsFiberLaserPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1570">
      <SeoBar data-id="element-1571" />
      <Header data-id="element-1572" />
      <main className="flex-grow" data-id="element-1573">
        <div className="w-full bg-gray-50 pb-20" data-id="element-1574">
          <HeroSection data-id="element-1575" />
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-1576">
            <IntroSection data-id="element-1577" />
            <FiberAdvantagesSection data-id="element-1578" />
            <CO2AdvantagesSection data-id="element-1579" />
            <CO2DisadvantagesSection data-id="element-1580" />
            <VideosSection data-id="element-1581" />
            <AdditionalLinksSection data-id="element-1582" />
          </div>
        </div>
      </main>
      <Footer data-id="element-1583" />
    </div>;
}